var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-card',{attrs:{"cancel-text":'_.close',"title":_vm.$t('_.select_product')},on:{"close":function($event){return _vm.$emit('close')}}},[_c('guard',{attrs:{"if-admin":_vm.guardFunctionalities,"if-client":true}},[_c('products-table',{attrs:{"account-id":_vm.accountId,"segment-type":_vm.segmentType,"segmented-view":false,"ignore-history":true,"limit":5,"row-tag":"a","row-events":function (contractProduct) {
        var _obj;

        return (( _obj = {}, _obj['click'] = function () { return _vm.selectProduct(contractProduct); }, _obj ));
}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }